export default __webpack_public_path__ + "static/media/seloger-logo.ce0a954d.png";